/** Открыть личку с клиентом из Telegram Mini App или браузера. */

export type WebAppUser = {
  id?: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  photo_url?: string;
  is_premium?: boolean;
};

export type MiniAppBridge = {
  ready?: () => void;
  expand?: () => void;
  initData?: string;
  initDataUnsafe?: {
    user?: WebAppUser;
    query_id?: string;
    auth_date?: number;
    hash?: string;
  };
  openTelegramLink?: (url: string) => void;
  openLink?: (url: string, opts?: { try_instant_view?: boolean }) => void;
};

declare global {
  interface Window {
    Telegram?: { WebApp?: MiniAppBridge };
  }
}

export function openTelegramUserDm(telegramId: number | null | undefined, username?: string | null): void {
  if (telegramId == null || !Number.isFinite(Number(telegramId))) return;

  const id = Number(telegramId);
  const unameRaw = (username ?? '').trim().replace(/^@+/, '').replace(/\s+/g, '');
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

  const openHttps = (url: string) => {
    if (tg?.openTelegramLink) {
      tg.openTelegramLink(url);
      return;
    }
    if (tg?.openLink) {
      tg.openLink(url);
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const openDeep = (url: string) => {
    if (tg?.openLink) {
      tg.openLink(url, { try_instant_view: false });
      return;
    }
    window.location.href = url;
  };

  if (unameRaw && /^[a-zA-Z0-9_]{4,}$/.test(unameRaw)) {
    openHttps(`https://t.me/${encodeURIComponent(unameRaw)}`);
    return;
  }

  openDeep(`tg://user?id=${id}`);
}
